import { Container, Image, Row,Col, Card } from "react-bootstrap"
import './Style/Footer.css';
import {AiFillYoutube,AiOutlineInstagram,AiFillTwitterCircle} from "react-icons/ai";
import {BsFacebook} from 'react-icons/bs';
function Footer(){
    return(
        <Container fluid className="footer pt-5" style={{backgroundColor:"rgb(247, 248, 253)"}}>
            <Row className="footerLine gap-4">
                <Col xs="12" md="3" className="p-3 ps-5 p-md-0">
                <Image fluid className="me-lg-3" src="./imgs/logos.png" style={{maxWidth:"70px",backgroundColor:"white"}}/>
                </Col>
                <Col xs="12"  md="4">
                <h1 className="p-3 p-md-0">لماذا تختارنا</h1>
                <ul className="m-0 p-3 p-md-0">
                    <li className="pb-1">سياسة الخصوصية</li>
                    <li className="pb-1">تواصل معنا</li>
                    <li className="pb-1">الشروط والأحكام</li>
                    <li className="pb-1">سياسة الاسترجاع</li>
                </ul>
                </Col>
                <Col xs="12"  md="4" className="p-4 pt-0">

                <Card className="border-0 rounded-4 p-lg-3">
                    <Card.Body>
                    <h2>حمل التطبيق من هنا</h2>
                <p>
                ستتلقى فقط رسائل البريد الإلكتروني المتعلقة بالعروض الترويجية Black November . لن نرسل لك بريدًا عشوائيًا
                </p>
                <div className="pb-2" style={{maxWidth:"calc(13vw + 22px)"}}><Image fluid src="./imgs/google.png"/></div>
                <div style={{maxWidth:"calc(13vw + 22px)"}}><Image fluid src="./imgs/apple.png"/></div>
                    </Card.Body>
                </Card>
                </Col>
            </Row>
            <Row className="p-4  footerLine">
                <Col xs="12" md="6" className="pb-3 p-md-0">
                <h5>يمكنك مراسلتنا من خلال</h5>
                <div><span><AiFillYoutube className="fs-4 rounded-5 ms-2 p-2 p-2 text-white" style={{width:"3rem",height:"3rem",background:"#e63946"}}/></span>
                <span ><AiOutlineInstagram className="rounded-5 fs-4 p-2 text-white" style={{width:"3rem",height:"3rem",background:"radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%"}}/></span>
                <span><AiFillTwitterCircle className="fs-4 m-1" style={{width:"3.5rem",height:"3.5rem",color:"#1da1f2"}}/></span>
                <span ><BsFacebook className="fs-4 " style={{width:"3rem",height:"3rem",color:"#0f70b7"}}/></span></div>
                </Col>
                <Col xs="12" md="6" className="d-flex align-items-center gap-4" >
                <div className="">
                    <h5>البريد الإلكتروني للاستفسار</h5>
                    <h5>support@framelancer.io</h5>
                </div>
                <div>
                    <h5>رقم خدمة العملاء</h5>
                    <h5>0115107120</h5>
                </div>
                </Col>
            </Row>
            <Row style={{backgroundColor:"#292930"}}> 
                <h6 className="text-center text-white m-0 pt-2 pb-2">.Copyright 2023 framelancer<span className="pe-1">©</span> </h6>
            </Row>
        </Container>
    )
}

export default Footer;